import React, { useState, useEffect } from "react";

// import Table from "react-bootstrap/Table";
import "./Simpal.css";
import { connect } from "react-redux";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box, Pagination } from "@mui/material";
import PropTypes from "prop-types";
 import DoubleScrollbar from "react-double-scrollbar";

 import $ from "jquery";
import {
  applyProperty,
  getPropertyDetail,
  hiddenProperty,
  likeProperty,
  unlikeProperty,
} from "../../actions/propertyAction";

import _ from "lodash";

import {
  Fix_value,
  settings,
  silderData,
  home_appliances,
  restrictions_val,
  images,
} from "../Property-info4/propertyArray";

import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Table,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  Spinner,
} from "reactstrap";
import { BsFillCameraFill } from "react-icons/bs";
import { FaDog, FaSmoking, FaKorvue, FaRegBuilding } from "react-icons/fa";

import { FcCheckmark } from "react-icons/fc";

import { GiSofa, GiHomeGarage } from "react-icons/gi";
import { ImCross } from "react-icons/im";
import {
  AiOutlineEyeInvisible,
  AiOutlineHeart,
  AiFillWechat,
  AiFillHeart,
} from "react-icons/ai";
import { GoLocation } from "react-icons/go";
import { BsQuestion } from "react-icons/bs";
import { IoLocationSharp } from "react-icons/io5";
import { getPropertyList } from "../../actions/propertyAction";
import { loadUser } from "../../actions/authActions";
import moment from "moment";
import { Link, Redirect, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";
import { useSelector } from "react-redux";
import InfiniteScrollWrapper from "./InfinteScrollWrapper";
let rowsPerPage = 20;

const TableData = ({
  allData,
  properties,
  getPropertyList,
  getPropertyDetail,
  auth,
  applyProperty,
  hiddenProperty,
  likeProperty,
  unlikeProperty,
  page,
  changePage,
  filterLoading,
  label,setOrderBy,orderBy,order,setOrder
}) => {
  const history = useHistory();
  const { frontLabelsName } = label;
  const isAuth = auth.isAuthenticated;
  const userName = auth.user;

  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const { property, propertyLoading } = useSelector(
    (state) => state.properties
  );

  const handleRequestSort = (property) => {
    setOrderBy(property)
  
     
      setOrder(order === "asc" ? "desc" : "asc");
      changePage(1)
    
  };

  const getMoreData = () => {
    if (property?.hasNextPage) {
      changePage((prev) => prev + 1);
      setHasMore(true);
    } else {
      setHasMore(false);
    }
    // setPage((prev)=>prev + 1)
  };


  useEffect(() => {
    // setLoading(true);
    // getPropertyList(
    //   page == undefined ? 1 : page,
    //   rowsPerPage,
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   ""
    // ).then((res) => {
    //   setLoading(false);
    // });
  }, [getPropertyList, page]);

  // const getMoreData = () => {
  //   if (property.totalPages != property.page) {
  //     setPage(page + 1);
  //     setHasMore(false);
  //   }
  // };

  const onDoubleScrollLoad =()=>{
    $('.table-responsive').doubleScroll();
    $('.table-responsive')[0].style.height="655px";
    $('.table-responsive')[0].style.overflow = "auto";
   
  }
  (function( $ ) {
 	
    $.fn.doubleScroll = function(userOptions) {
   
     // Default options
     var options = {
       contentElement: undefined, // Widest element, if not specified first child element will be used
       scrollCss: {                
         'overflow-x': 'auto',
         'overflow-y': 'hidden'
       },
       contentCss: {
         'overflow-x': 'auto',
         'overflow-y': 'hidden'
       },
       onlyIfScroll: true, // top scrollbar is not shown if the bottom one is not present
       resetOnWindowResize: false, // recompute the top ScrollBar requirements when the window is resized
       timeToWaitForResize: 30 // wait for the last update event (usefull when browser fire resize event constantly during ressing)
     };
   
     $.extend(true, options, userOptions);
   
     // do not modify
     // internal stuff
     $.extend(options, {
       topScrollBarMarkup: '<div class="doubleScroll-scroll-wrapper" style="height: 20px;"><div class="doubleScroll-scroll" style="height: 20px;"></div></div>',
       topScrollBarWrapperSelector: '.doubleScroll-scroll-wrapper',
       topScrollBarInnerSelector: '.doubleScroll-scroll'
     });
    
     var _showScrollBar = function($self, options) {
 
       if (options.onlyIfScroll && $self.get(0).scrollWidth <= $self.width()) {
         // content doesn't scroll
         // remove any existing occurrence...
         $self.prev(options.topScrollBarWrapperSelector).remove();
         return;
       }
     
       // add div that will act as an upper scroll only if not already added to the DOM
       var $topScrollBar = $self.prev(options.topScrollBarWrapperSelector);
       
       if ($topScrollBar.length == 0) {
         
         // creating the scrollbar
         // added before in the DOM
         $topScrollBar = $(options.topScrollBarMarkup);
         $self.before($topScrollBar);
 
         // apply the css
         $topScrollBar.css(options.scrollCss);
         $self.css(options.contentCss);
 
         // bind upper scroll to bottom scroll
         $topScrollBar.bind('scroll.doubleScroll', function() {
           $self.scrollLeft($topScrollBar.scrollLeft());
         });
 
         // bind bottom scroll to upper scroll
         var selfScrollHandler = function() {
           $topScrollBar.scrollLeft($self.scrollLeft());
         };
         $self.bind('scroll.doubleScroll', selfScrollHandler);
       }
 
       // find the content element (should be the widest one)	
       var $contentElement;		
       
       if (options.contentElement !== undefined && $self.find(options.contentElement).length !== 0) {
         $contentElement = $self.find(options.contentElement);
       } else {
         $contentElement = $self.find('>:first-child');
       }
       
       // set the width of the wrappers
       $(options.topScrollBarInnerSelector, $topScrollBar).width($contentElement.outerWidth());
       $topScrollBar.width($self.width());
       $topScrollBar.scrollLeft($self.scrollLeft());
       
     }
   
     return this.each(function() {
       
       var $self = $(this);
       
       _showScrollBar($self, options);
       
       // bind the resize handler 
       // do it once
       if (options.resetOnWindowResize) {
       
         var id;
         var handler = function(e) {
           _showScrollBar($self, options);
         };
       
         $(window).bind('resize.doubleScroll', function() {
           // adding/removing/replacing the scrollbar might resize the window
           // so the resizing flag will avoid the infinite loop here...
           clearTimeout(id);
           id = setTimeout(handler, options.timeToWaitForResize);
         });
 
       }
 
     });
 
   }
 
 }( $ ));

  const handleChange = (e, p) => {
    page && changePage(p);
    getPropertyList(
      p,
      rowsPerPage,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    );
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: "#f5d792",
        darker: "#053e85",
      },
      neutral: {
        main: "#64748B",
        contrastText: "#fff",
      },
    },
  });

  // const hidden = () => {
  //   if (auth.isAuthenticated) {
  //     history.push("/hidden-properties");
  //   } else {
  //     toast.error("Please login to access this button");
  //   }
  // };

  // const favourite = () => {
  //   if (auth.isAuthenticated) {
  //     history.push("/favourite-properties");
  //   } else {
  //     toast.error("Please login to access this button");
  //   }
  // };

  const loginCheck = async (e, id) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      const data = {
        property: id,
      };
      const res = await applyProperty(data).then((res) => {
        getPropertyList(
          page == undefined ? 1 : page,
          rowsPerPage,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        );
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == res.message).length > 0
              ? frontLabelsName.filter((e) => e.key == res.message)[0]["value"] ||
                res.message
              : res.message
            : res.message
        );
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_please_login_to_access"
              )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  // hidden property

  const hidden = async (e, id) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      let newhidden = {
        property_id: id,
      };
      const res = hiddenProperty(newhidden).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.message)[0]["value"] ||
                ress.message
              : ress.message
            : ress.message
        );
        getPropertyList(
          page,
          rowsPerPage,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        );
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_please_login_to_access"
              )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  const like = async (e, id) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      let newAddLike = {
        property_id: id,
      };
      const res = await likeProperty(newAddLike).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.message)[0]["value"] ||
                ress.message
              : ress.message
            : ress.message
        );
        getPropertyList(
          page,
          rowsPerPage,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        );
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_please_login_to_access"
              )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  // end here like and unlike

  const unlike = async (e, id) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      const res = await unlikeProperty(id).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.message)[0]["value"] ||
                ress.message
              : ress.message
            : ress.message
        );
        getPropertyList(
          page,
          rowsPerPage,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        );
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_please_login_to_access"
              )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  const getTypeName = (val) => {
    if (val === "detachedHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_detached_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_detached_house")[0][
              "value"
            ] || "lbl_detached_house"
          : "lbl_detached_house"
        : "lbl_detached_house";
    } else if (val === "duplex") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_duplex").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_duplex")[0]["value"] ||
            "lbl_duplex"
          : "lbl_duplex"
        : "lbl_duplex";
    } else if (val === "tripleAptHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house")[0][
              "value"
            ] || "lbl_triple_apt_house"
          : "lbl_triple_apt_house"
        : "lbl_triple_apt_house";
    } else if (val === "aptBulding") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_apt_building").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_apt_building")[0]["value"] ||
            "lbl_apt_building"
          : "lbl_apt_building"
        : "lbl_apt_building";
    } else if (val === "townhouseTwin") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin")[0][
              "value"
            ] || "lbl_townhouse_twin"
          : "lbl_townhouse_twin"
        : "lbl_townhouse_twin";
    } else if (val === "garage") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0]["value"] ||
            "lbl_garage"
          : "lbl_garage"
        : "lbl_garage";
    } else if (val === "summerHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_summer_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_summer_house")[0]["value"] ||
            "lbl_summer_house"
          : "lbl_summer_house"
        : "lbl_summer_house";
    } else if (val === "cotenant") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant")[0]["value"] ||
            "lbl_co_tenant"
          : "lbl_co_tenant"
        : "lbl_co_tenant";
    } else if (val === "hotelGesthouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house")[0][
              "value"
            ] || "lbl_hotel_guest_house"
          : "lbl_hotel_guest_house"
        : "lbl_hotel_guest_house";
    }
  };

  

  return (
    <>
      {filterLoading && <Loading />}
      {!loading && !propertyLoading && !filterLoading && (
        <div className="px-3 tableStyle"   >
      
          <div className="table-style-custom w-100" >
         
       
          <InfiniteScrollWrapper
        isInfiniteScrollOn={true}
        lengthData={properties.length}
        functionNext={getMoreData}
        hasMore={property?.hasNextPage}
      
      >
      
{/* <div className="double-scroll" onLoad={onDoubleScrollLoad}> */}
           <Table className="table list-view-table mt-4" responsive striped   >
    
         <thead >
       
                <tr   >
                  <th  >
              <div className="chat-tooltip"> 
                    <img
                      src="assets/table_icons/Icon material-camera-alt.svg"
                      width="15"
                      height="15"
                      alt="propertyphoto"
                    />
                  <span class="tooltiptextphot">{frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_photo").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_photo")[0][
              "value"
            ] || "lbl_photo"
          : "lbl_photo"
        : "lbl_photo"}</span> 
    </div> 
                  </th>
                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_registered")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_registered"
                          )[0]["value"] || "lbl_registered"
                        : "lbl_registered"
                      : "lbl_registered"}
                  </th>
                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_herb").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_herb")[0][
                            "value"
                          ] || "lbl_herb"
                        : "lbl_herb"
                      : "lbl_herb"}
                  </th>
                  <th>
                    m<sup>2</sup>
                  </th>
                  <th style={{cursor:"pointer"}}    onClick={() => {
                          handleRequestSort("propertyPrice_sort");
                        }}>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_rent").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_rent")[0][
                            "value"
                          ] || "lbl_rent"
                        : "lbl_rent"
                      : "lbl_rent"}
                          {orderBy === "propertyPrice_sort" ? (
                            <img
                              src={
                                order === "desc"?
                                   "assets/icons/down-arrow.svg"
                                   : "assets/icons/up-arrow.svg"
                          
                              }
                              alt="sort-arrow"
                              className="sort-arrow"
                            />
                          ) : (
                      null
                          )}
                  </th>
                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_pnr").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_pnr")[0][
                            "value"
                          ] || "lbl_pnr"
                        : "lbl_pnr"
                      : "lbl_pnr"}
                  </th>
                  <th colSpan={1}>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_address")
                          .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_address")[0][
                            "value"
                          ] || "lbl_address"
                        : "lbl_address"
                      : "lbl_address"}
                  </th>

                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_type").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_type")[0][
                            "value"
                          ] || "lbl_type"
                        : "lbl_type"
                      : "lbl_type"}
                  </th>
                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_delivery")
                          .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_delivery")[0][
                            "value"
                          ] || "lbl_delivery"
                        : "lbl_delivery"
                      : "lbl_delivery"}
                  </th>
                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_rented_to")
                          .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_rented_to")[0][
                            "value"
                          ] || "lbl_rented_to"
                        : "lbl_rented_to"
                      : "lbl_rented_to"}
                  </th>
                  <th >
                    <div className="chat-tooltip">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_sk").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_sk")[0][
                            "value"
                          ] || "lbl_sk"
                        : "lbl_sk"
                      : "lbl_sk"}
                       <span class="tooltiptext">{frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_views").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_views")[0][
              "value"
            ] || "lbl_views"
          : "lbl_views"
        : "lbl_views"}</span> 
        </div> 
                  </th>
                  <th >
                    <div className="chat-tooltip">
                    <img
                      src="assets/table_icons/Icon awesome-dog.svg"
                      width="15"
                      height="15"
                      alt="pets"
                    />
                        <span class="tooltiptext">{frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_pets").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_pets")[0][
              "value"
            ] || "lbl_pets"
          : "lbl_pets"
        : "lbl_pets"}</span>  
        </div>
                  </th>

                  <th >
                    <div className="chat-tooltip">
                    <img
                      src="assets/table_icons/furniture-14-svgrepo-com.svg"
                      width="15"
                      height="15"
                      alt="furniture"
                    />
                     <span class="tooltiptext">{frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_furniture").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_furniture")[0][
              "value"
            ] || "lbl_furniture"
          : "lbl_furniture"
        : "lbl_furniture"}</span>  
        </div>
                  </th>

                  <th >
                    <div className="chat-tooltip">
                    <img
                      src="assets/table_icons/Icon awesome-smoking.svg"
                      width="15"
                      height="15"
                      alt="smoking"
                    />
                          <span class="tooltiptext">{frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_smoking").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_smoking")[0][
              "value"
            ] || "lbl_smoking"
          : "lbl_smoking"
        : "lbl_smoking"}</span>  
        </div>
                  </th>
                  <th >
                    <div className="chat-tooltip">
                    <img
                      src="assets/table_icons/garage.svg"
                      width="15"
                      height="15"
                      alt="garage"
                    />
                      <span class="tooltiptext">{frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0][
              "value"
            ] || "lbl_garage"
          : "lbl_garage"
        : "lbl_garage"}</span>  
        </div>
                  </th>
                 <th>
                 <div className="chat-tooltip">
                    <img
                      src="assets/table_icons/K.svg"
                      width="15"
                      height="15"
                      alt="restriction"
                    />
                                      <span class="tooltiptext">{frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_restrictions").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_restrictions")[0][
              "value"
            ] || "lbl_restrictions"
          : "lbl_restrictions"
        : "lbl_restrictions"}</span>  
        </div>
                  </th>
                  {/* <th>
                    <img
                      src="assets/table_icons/Favourite (1).svg"
                      width="15"
                      height="15"
                    />
                  </th> */}
                  <th >
                    <div className="chat-tooltip">
                    <img
                      src="assets/table_icons/Favourite (2).svg"
                      width="15"
                      height="15"
                      alt="favorite"
                    />
                       <span class="tooltiptext">{frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_favourite").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_favourite")[0][
              "value"
            ] || "lbl_favourite"
          : "lbl_favourite"
        : "lbl_favourite"}</span>  
        </div>
                  </th>
                  {/* <th>
                    <img
                      src="assets/table_icons/Icon material-location-on.svg"
                      width="15"
                      height="15"
                    />
                  </th> */}
                  <th >
                    <div className="chat-tooltip">

               
                  <img
                      src="assets/table_icons/Icon zocial-email.svg"
                      width="15"
                      height="15"
                      alt="chat"
                    />
                
 <span class="tooltiptext">{frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_chat_with_owner").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_chat_with_owner")[0][
              "value"
            ] || "lbl_chat_with_owner"
          : "lbl_chat_with_owner"
        : "lbl_chat_with_owner"}</span>  

</div>
                  </th>
                  <th >
                    <div className="chat-tooltip">
                    <img
                      src="assets/table_icons/Group 13974.svg"
                      width="15"
                      height="15"
                      alt="apply"
                    />
                     <span class="tooltiptext">{frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_apply_property").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_apply_property")[0][
              "value"
            ] || "lbl_apply_property"
          : "lbl_apply_property"
        : "lbl_apply_property"}</span>  
        </div>
                  </th>
                </tr>
    
              </thead>
             
              <tbody>
                { !propertyLoading && properties.length > 0 && (
                  properties.map((obj, indx) => {
                    // please dont change code becoz we are mange.
                    let right = _.differenceBy(Fix_value, obj?.included);
                    let righthomeapp = _.differenceBy(
                      home_appliances,
                      obj?.homeAppliances
                    );

                    let rightrestrictions = _.differenceBy(
                      restrictions_val,
                      obj?.restrictions
                    );

                    

                    return (
                      // <Link to={`property-details/${obj?._id}`}>
                      <tr key={indx}>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          {obj?.photo_gallery.length}
                        </td>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          {moment(obj?.createdAt).format("DD/MM/YY")}
                        </td>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer",paddingLeft:"3px",paddingRight:"3px" }}
                        >
                       
                          {obj?.bhk === "Storage"
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_storage")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_storage"
                                  )[0]["value"] || "lbl_storage"
                                : "lbl_storage"
                              : "lbl_storage"
                            : ""}
                          {obj?.bhk === "Single Room"
                            ? 1
                            : ""}
                          {obj?.bhk === "Studio"
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_studio")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_studio"
                                  )[0]["value"] || "lbl_studio"
                                : "lbl_studio"
                              : "lbl_studio"
                            : ""}
                          {obj?.bhk !== "Studio" &&
                          obj?.bhk !== "Single Room" &&
                          obj?.bhk !== "Storage"
                            ? obj?.bhk
                            : ""}
                        
                        </td>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                               <div className="chat-tooltip">
                          {obj?.size?.toString().length>3 ? obj?.size?.toString().substring(0,3) + "..." :obj?.size}
                          { obj?.size?.toString().length>3 &&    <span class="tooltiptext">{obj?.size}</span>  }
                        </div>
                     
                        </td>
                        <td
                     
                          style={{ cursor: "pointer" }}
      
                        >
                        
                           <div className="chat-tooltip">
                          {obj?.propertyPrice?.toString().length>5 ? obj?.propertyPrice?.toString().substring(0,5) + "..." :obj?.propertyPrice}
                          { obj?.propertyPrice?.toString().length>5 &&    <span class="tooltiptext">{obj?.propertyPrice}</span>  }
                        </div>
                        </td>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                            <div className="chat-tooltip">
                          {obj?.area?.toString().length >3 ? obj?.area?.toString().substring(0, 3) + " ...":obj?.area}
                          { obj.area?.toString().length > 3 &&    <span class="tooltiptext">{obj?.area}</span>  }
                        </div>
                        </td>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer",position:"relative" }}
                          className="list-view-location-td"
                        >
                        <div className="chat-tooltip">
                          {`${
                          obj.location.length > 30
                            ? obj.location.substring(0, 30) + " ..."
                            : obj.location
                        } `}
                        { obj.location.length > 30 &&    <span class="tooltiptextaae">{obj.location}</span>  }
                        </div>
                          
                        </td>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer",paddingLeft:"3px",paddingRight:"3px" }}
                        >
                              <div className="chat-tooltip">
                          {getTypeName(obj?.propertyType).length>6 ? getTypeName(obj?.propertyType).substring(0,6) + "..." : getTypeName(obj?.propertyType) }
                          { getTypeName(obj?.propertyType).length>6 &&    <span class="tooltiptextaae">{getTypeName(obj?.propertyType)}</span>  }
                          </div>
                        </td>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                    <div className="chat-tooltip">

{obj?.availability === "true"
                            ? (frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_available_right_away"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_available_right_away"
                                  )[0]["value"] || "lbl_available_right_away"
                                : "lbl_available_right_away"
                              : "lbl_available_right_away").substring(0, 8) + " ..."
                            : ""}
                          {obj?.availabilityDate
                            ? moment(obj?.availabilityDate).format("DD/MM/YY")
                            : ""}
                             {obj?.availability === "true"  &&    <span class="tooltiptextaae">{frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_available_right_away"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_available_right_away"
                                    )[0]["value"] || "lbl_available_right_away"
                                  : "lbl_available_right_away"
                                : "lbl_available_right_away"}</span>  }
                                </div>    
                        </td>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                                              <div className="chat-tooltip">
                        {obj?.deliveryDate
                            ? moment(obj?.deliveryDate).format("DD/MM/YY")
                            : ""}
                          {obj?.deliveryRightAway === true
                            ? (frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_long_term"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_long_term"
                                  )[0]["value"] || "lbl_long_term"
                                : "lbl_long_term"
                              : "lbl_long_term").substring(0, 8) + " ..."
                            : ""}
                              {obj?.deliveryRightAway === true
                            && <span class="tooltiptextaae">{frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_long_term"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_long_term"
                                  )[0]["value"] || "lbl_long_term"
                                : "lbl_long_term"
                              : "lbl_long_term"}</span>  }
                               </div>
                        </td>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          {obj?.views}
                        </td>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          {obj?.pets == 1 ? (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-check.svg"
                              width="15"
                              height="15"
                            />
                          ) : obj?.pets == 2 ? (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-plus.svg"
                              width="15"
                              height="15"
                            />
                          ) : (
                            <img
                              src="assets/table_icons/innar-icons/Icon awesome-question.svg"
                              width="15"
                              height="15"
                            />
                          )}
                        </td>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          {obj?.with_furniture == 1 ? (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-check.svg"
                              width="15"
                              height="15"
                            />
                          ) : obj?.with_furniture == 2 ? (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-plus.svg"
                              width="15"
                              height="15"
                            />
                          ) : (
                            <img
                              src="assets/table_icons/innar-icons/Icon awesome-question.svg"
                              width="15"
                              height="15"
                            />
                          )}
                        </td>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          {obj?.smoking == 1 ? (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-check.svg"
                              width="15"
                              height="15"
                            />
                          ) : obj?.smoking == 2 ? (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-plus.svg"
                              width="15"
                              height="15"
                            />
                          ) : (
                            <img
                              src="assets/table_icons/innar-icons/Icon awesome-question.svg"
                              width="15"
                              height="15"
                            />
                          )}
                        </td>
                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          {obj?.garage == 1 ? (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-check.svg"
                              width="15"
                              height="15"
                            />
                          ) : obj?.garage == 2 ? (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-plus.svg"
                              width="15"
                              height="15"
                            />
                          ) : (
                            <img
                              src="assets/table_icons/innar-icons/Icon awesome-question.svg"
                              width="15"
                              height="15"
                            />
                          )}
                        </td>

                        <td
                          onClick={() =>
                            history.push(`/property-details/${obj?._id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                       {obj?.restrictions.length>0 ?   (
                        <img
                        src="assets/table_icons/innar-icons/Icon feather-check.svg"
                        width="15"
                        height="15"
                        alt="restriction"
                      />
                        ) :     <img
                        src="assets/table_icons/innar-icons/Icon feather-plus.svg"
                        width="15"
                        height="15"
                        alt="restriction"
                      />    }
                        </td>
                        {/* <td>
                          <img
                            src="assets/table_icons/innar-icons/Favourite (1).svg"
                            width="15"
                            height="15"
                            onClick={(e) => hidden(e, obj?._id)}
                            style={{ cursor: "pointer" }}
                          />
                        </td> */}
                        <td>
                          {obj?.favourite == 0 ? (
                            <img
                              src="assets/unfav.svg"
                              width="15"
                              height="15"
                              onClick={(e) => like(e, obj?._id)}
                              style={{ cursor: "pointer" }}
                            />
                          ) : (
                            <img
                              src="assets/like.svg"
                              width="15"
                              height="15"
                              onClick={(e) => unlike(e, obj?._id)}
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </td>
                     {/* <td>
                          <Link
                            to={{
                              pathname: `/properties-map`,
                              state: { user: obj },
                            }}
                          >
                            <IoLocationSharp
                              style={{
                                width: "20px !important",
                                height: "20px !important",
                                color: "black",
                              }}
                            />
                          </Link>
                        </td>  */}
                        <td>
                          <Link to="/chat-view">
                            <img
                              src="assets/table_icons/innar-icons/Icon zocial-email.svg"
                              width="15"
                              height="15"
                              style={{ cursor: "pointer" }}
                            />
                          </Link>
                        </td>

                        <td>
                          {obj?.applied === 0 ? (
                            <img
                              src="assets/table_icons/innar-icons/Group 13975.svg"
                              width="15"
                              height="15"
                              onClick={(e) => loginCheck(e, obj?._id)}
                              style={{ cursor: "pointer" }}
                            />
                          ) : (
                            <img
                              src="assets/table_icons/innar-icons/Group 13975.svg"
                              width="15"
                              height="15"
                              className="disable-links"
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </td>
                      </tr>
                      // </Link>
                    );
                  })
              
                )  }
                { !propertyLoading && properties.length == 0&&(
                  <tr>
                    <td colSpan={22} className="text-center">
                      <p className="mb-0">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_no_property_found_criteria"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_no_property_found_criteria"
                              )[0]["value"] || "lbl_no_property_found_criteria"
                            : "lbl_no_property_found_criteria"
                          : "lbl_no_property_found_criteria"}
                      </p>
                    </td>
                  </tr>
                )}
                    </tbody>
                  
                    </Table>
                    {/* </div> */}
                    </InfiniteScrollWrapper>
       

            <div className="d-flex set-align pt-2">
              {/* <Box display="flex" justifyContent="center" alignItems="center">
                <ThemeProvider theme={theme}>
                  {!loading && !propertyLoading && (
                    <Pagination
                      count={property.totalPages}
                      color="primary"
                      page={page}
                      onChange={handleChange}
                      shape="rounded"
                      sx={{ textAlign: "center" }}
                    />
                  )}
                </ThemeProvider>
              </Box> */}

              <div className="right-corner-status">
                <div className="d-flex cu-position-set" >
                  <div className="set-flex" style={{height:"55px"}}>
                    <span className="ml-3">
                      <img
                        src="assets/table_icons/innar-icons/Icon feather-check.svg"
                        width="15"
                        height="15"
                        className="gap-set"
                      />
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_yes_included")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_yes_included"
                            )[0]["value"] || "lbl_yes_included"
                          : "lbl_yes_included"
                        : "lbl_yes_included"}
                    </span>
                  </div>
                  <div className="set-flex" style={{height:"55px"}}>
                    <span>
                      <img
                        src="assets/table_icons/innar-icons/Icon feather-plus.svg"
                        width="15"
                        height="15"
                        className="gap-set"
                      />
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_no_not_included"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_no_not_included"
                            )[0]["value"] || "lbl_no_not_included"
                          : "lbl_no_not_included"
                        : "lbl_no_not_included"}
                    </span>
                  </div>
                  <div className="set-flex" style={{height:"55px"}}>
                    <span>
                      <img
                        src="assets/table_icons/innar-icons/Icon awesome-question.svg"
                        width="15"
                        height="15"
                        className="gap-set"
                      />
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_agreement")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_agreement"
                            )[0]["value"] || "lbl_agreement"
                          : "lbl_agreement"
                        : "lbl_agreement"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
 
        </div>
      )}

      {loading && <Loading />}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  label: state.language,
});

export default connect(mapStateToProps, {
  getPropertyList,
  getPropertyDetail,
  loadUser,
  applyProperty,
  hiddenProperty,
  likeProperty,
  unlikeProperty,
})(TableData);
